<template>
  <div class="feedback">
    <div class="left-content">
      <span>资源上传下载、课程学习等过程中有任何疑问或建议，欢迎提出宝贵意见哦~我们会及时处理！</span>
      <a class="btn mt-8" href="https://gitcode.net/csdn/download/-/issues" target="_blank">
        点击此处反馈
        <img src="https://img-home.csdnimg.cn/images/20220527035711.png" />
      </a>
    </div>
    <img src="https://img-home.csdnimg.cn/images/20220527035111.png" class="right-img ml-16">
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.feedback {
  margin-top: 10px;
  padding: 20px 24px;
  background: white;
  display: flex;
  flex-direction: row;
  .left-content {
    font-size: 13px;
    color: #222226;
    line-height: 22px;
    .btn {
      font-size: 14px;
      color: #277CCC;
      line-height: 22px;
      display: flex;
      align-items: center;
      img {
        width: 9px;
        height: 14px;
        margin-left: 6px;
      }
    }
  }
  .right-img {
    height: 88px;
    width: 88px;
  }
}
</style>